'use es6';

import keyMirror from 'react-utils/keyMirror';
export default keyMirror({
  UPDATE_TOTP: null,
  SET_TOKEN: null,
  SET_TWO_FACTOR_METHOD: null,
  SWITCH_TWO_FACTOR_METHOD: null,
  SET_CREDENTIALS: null,
  TOGGLE_REMEMBER_DEVICE: null,
  SWITCH_APP_STATE: null,
  START_VERIFYING: null,
  FINISH_VERIFYING: null,
  START_REQUESTING_CODE: null,
  FINISH_REQUESTING_CODE: null,
  SHOW_TOKEN_EXPIRED: null,
  HIDE_TOKEN_EXPIRED: null,
  SHOW_NEW_CODE_SENT: null,
  HIDE_NEW_CODE_SENT: null,
  SHOW_INVALID_CODE: null,
  HIDE_INVALID_CODE: null,
  SHOW_INVALID_TOKEN: null,
  HIDE_INVALID_TOKEN: null,
  SHOW_SMS_RATE_LIMIT: null,
  HIDE_SMS_RATE_LIMIT: null,
  SHOW_USER_DEACTIVATED: null,
  HIDE_USER_DEACTIVATED: null,
  SHOW_GENERIC_TWO_FACTOR_ERROR: null,
  HIDE_GENERIC_TWO_FACTOR_ERROR: null,
  CLICKED_BACK_BUTTON: null,
  FETCH_HUBSPOT_APP_STATUS: null,
  UPDATE_HUBSPOT_APP_STATUS: null,
  TOGGLE_REMEMBER_DEVICE_MODAL: null,
  LOGIN_WITH_HS_PROMPT: null
});